import BaseAPI from '@/apis/base/baseApi';
import httpclient from '../base/httpclient';
class NotificationApi extends BaseAPI {
  apiName = 'Business';
  controllerName = 'Notifications';

  /**
   * Lấy thông báo mới nhất
   * ndhieu3 25.09.2023
   */
  getNewestNoti() {
    try {
      let request = {
        url: this.getAPIUrl() + '/newest-noti',
      };
      return httpclient.getAsync(request);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Lấy ds thông báo
   */
  getAllNotification(payload) {
    let request = {
      url: this.getAPIUrl() + '/get-all',
      data: payload,
    };

    return httpclient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách
   */
  updateRead(payload) {
    let request = {
      url: this.getAPIUrl() + '/update-read',
      data: payload,
    };

    return httpclient.postAsync(request);
  }

  /**
   * Lấy số thông báo chưa đọc
   */
  getUnreadNotification(payload) {
    let request = {
      url: this.getAPIUrl() + '/get-unread',
      data: payload,
    };

    return httpclient.postAsync(request);
  }
}
export default new NotificationApi();
